import createIcon from '../../createIcon';

/**
 * @component @name VolumeMute
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy41IDlWMTVIMTEuNUwxNi41IDIwVjRMMTEuNSA5SDcuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VolumeMute = createIcon('VolumeMute', [
  ['path', { d: 'M7.5 9V15H11.5L16.5 20V4L11.5 9H7.5Z', key: 'z12lkt' }],
]);

export default VolumeMute;
